export const defaultFilterDrawerWidth = 352;
